import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { assets } from './assets';
export class AppTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }

  public getTranslation(lang: string): Observable<object> {
    const key = `/retired-arbitrum/assets/i18n/${lang}.js`;
    return this.http.jsonp(assets[key] || key, 'callback');
  }
}
